import React, { FC } from 'react';

const ItemIcon: FC = () => {
    return (
        <svg
            className="svg-inline"
            viewBox="0 0 26 26"
            fill="none"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.92712 17.4746H20.6935C20.8477 17.4746 20.9955 17.5359 21.1046 17.6449C21.2136 17.7539 21.2749 17.9018 21.2749 18.056V19.2028C21.2749 19.6396 21.1014 20.0585 20.7925 20.3673C20.4837 20.6762 20.0648 20.8497 19.628 20.8497H6.99255C6.77592 20.8497 6.56141 20.8069 6.36132 20.7239C6.16123 20.6409 5.97949 20.5192 5.82651 20.3658C5.67353 20.2124 5.55232 20.0304 5.46981 19.83C5.38731 19.6297 5.34514 19.4151 5.34571 19.1985V18.0444C5.34875 17.8922 5.41135 17.7473 5.52006 17.6408C5.62876 17.5342 5.77491 17.4746 5.92712 17.4746V17.4746Z"
                strokeWidth="1.6"
                strokeMiterlimit="10"
            />
            <path
                d="M5.3457 13.7461C6.94458 13.7461 6.94458 15.0644 8.53037 15.0644C10.1162 15.0644 10.1292 13.7461 11.7136 13.7461C13.2979 13.7461 13.3125 15.0644 14.8983 15.0644C16.484 15.0644 16.4971 13.7461 18.0844 13.7461C19.6716 13.7461 19.676 15.0644 21.269 15.0644"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M21.2412 11.3371H5.37305C5.37305 7.41259 8.92546 4.21484 13.3064 4.21484C17.6873 4.21484 21.2412 7.40678 21.2412 11.3371Z"
                strokeWidth="1.6"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ItemIcon;
